export const TEST_ID = 'pesticideLicensesCard';

export const ACTIONS_COLUMN_KEY = 'actions';

export const ACTIONS_COLUMN_LABEL = '';

export const ACTIONS_COLUMN_WIDTH = '56px';

export const EXPIRATION_DATE_COLUMN_KEY = 'expirationDate';

export const ISSUED_DATE_COLUMN_KEY = 'issuedDate';

export const LICENSE_NUMBER_COLUMN_KEY = 'licenseNumber';

export const STATE_COLUMN_KEY = 'state';

export const EMPTY_CELL_TEXT = '—';

export const DATE_LOCALE = 'en-US';

// UTC pinned so a date-only value keeps its calendar day for every viewer.
export const LICENSE_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    timeZone: 'UTC',
    year: 'numeric'
};
